var _rect, _rect2, _rect3, _path, _path2, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcCardIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 63",
    width: 35,
    height: 26,
    preserveAspectRatio: "xMidYMid meet",
    role: "img",
    "aria-label": "We accept Visa, Mastercard and American Express",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 98,
    height: 61,
    rx: 7,
    fill: "#fff",
    stroke: "#98a2b3",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12,
    width: 98,
    height: 11,
    fill: "#344054"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 16,
    height: 12,
    rx: 2.5,
    fill: "#e3b23c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 26v12M10 32h16",
    stroke: "#c08f24",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30.5a5 5 0 0 1 0 8M84 28a8.5 8.5 0 0 1 0 13M88 25.5a12 12 0 0 1 0 18",
    fill: "none",
    stroke: "#98a2b3",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 46,
    width: 24,
    height: 11,
    rx: 2,
    fill: "#f2f4f7",
    stroke: "#e4e7ec",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 54,
    textAnchor: "middle",
    fill: "#1a1f71",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 6,
    fontWeight: 700,
    fontStyle: "italic"
  }, "VISA"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 46,
    width: 24,
    height: 11,
    rx: 2,
    fill: "#f2f4f7",
    stroke: "#e4e7ec",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 51.5,
    r: 4,
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 51.5,
    r: 4,
    fill: "#f79e1b",
    fillOpacity: 0.85
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 46,
    width: 24,
    height: 11,
    rx: 2,
    fill: "#1f72cd"
  }), /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 53.8,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 5,
    fontWeight: 700
  }, "AMEX"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcCardIcons);
export default __webpack_public_path__ + "static/media/cc-card-icons.0b9c7cfce5af3f67fa7f90fef7c2b6ba.svg";
export { ForwardRef as ReactComponent };